import React from "react";
import { PublicClientApplication } from '@azure/msal-browser';
import ReactDOM from "react-dom/client";
import "./index.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import App from "./App";
import { msalConfig } from "./Auth/AuthConfig";
import { MsalProvider } from "@azure/msal-react";


const pca = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <MsalProvider instance={pca}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </MsalProvider>
);
